import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { recordListActions } from '../../config/configuration/react';
import { t } from '../../components/common/Translate';
import { buyerTabs } from '../../Store/actions/recordList/recordListActions';

const calculatePageCount = (numberRecords, recordsPerPage) =>
  Math.ceil(Math.max(recordsPerPage, numberRecords) / recordsPerPage);

export const useRecordList = (props) => {
  const dispatch = useDispatch();
  const urlParams = new URLSearchParams(props?.location?.search);
  const urlTab = urlParams.get('currentTab');
  const records = useSelector((state) => state.recordList.records) || [];
  const currentPage = useSelector((state) => state.recordList.currentPage);
  const recordPerPage = useSelector((state) => state.recordList.recordPerPage);
  const counts = useSelector((state) => state.recordList.counts);
  const currentTab = useSelector((state) => state.recordList.currentTab);
  const pageCount = calculatePageCount(counts[currentTab], recordPerPage);
  const loading = useSelector((state) => state.recordList.loading);
  const error = useSelector((state) => state.recordList.error);

  const searchCurrentTab = () => {
    dispatch(recordListActions.fetchBuyerRecordForCurrentTab());
  };

  const changeUrlTab = (tab) => {
    urlParams.set('currentTab', tab);
    window.history.pushState({}, '', `${props.location.pathname}?${urlParams.toString()}`);
  };

  const displayTab = (tab) => {
    changeUrlTab(tab);
    dispatch(recordListActions.displayTab(tab));
    searchCurrentTab();
  };

  const goToPage = (page) => {
    dispatch(recordListActions.goTopage(page));
    searchCurrentTab();
  };

  const generateTab = (type) => ({
    type,
    onClick: () => {
      displayTab(type);
    },
    count: counts[type],
    selected: type === currentTab,
    name: t(type),
  });

  const tabs = Object.keys(buyerTabs).map((type) => generateTab(type));

  useEffect(() => {
    if (!urlTab) changeUrlTab(currentTab || 'buyerOnGoing');
    else {
      const res = tabs.find((tab) => tab?.type === urlTab);
      if (res) displayTab(urlTab);
      else changeUrlTab(currentTab);
    }
  }, [urlTab]);

  const refresh = async () => {
    await dispatch(recordListActions.refreshBuyerRecordsCount());
    await dispatch(recordListActions.getUserFeeds());
    searchCurrentTab();
  };

  useEffect(() => {
    refresh();
  }, []);

  return { records, goToPage, pageCount, tabs, refresh, currentPage, loading, error, currentTab };
};
